<template>
    <base-input class="mb-3"
        :label="label"
        placeholder="HH:MM"
        :label-classes="labelClasses"
        :value="value"
        :name="name"
        :rules="rules"
        :error="error"
        @input="process"
    >
    </base-input>
</template>

<script>
    export default {

        props: {

            label: {
                type: String,
            },

            labelClasses: {
                type: String,
                default: "form-control-label"
            },

            value: {
                type: [String, Number],
            },

            name: {
                type: String,
                default: ''
            },

            rules: {
                type: [String, Array, Object],
                default: ''
            },

            error: {
                type: String,
            },
        },

        methods: {

            process(value) {
                const filtered = value.replace(/[^0-9]/g, '')
                    .replace(/^(\d{2})(\d{2})?/g, '$1:$2')
                    .substr(0, 5)

                this.$emit('input', filtered)
            }
        }
    }
</script>
